import { TYPE } from '@/constants';
import { Block } from './block';
import TableHelper from './tables/index';
import { Shape } from './shapes/shape';
import { PredefinedShape } from './predefined/predefined';
import { GAHelper } from './ga/index';
import { Text } from './text';
import SectionHelper from './sections/index';
import { Table } from './tables/table';
import { TableSeat } from './tables/tableSeat';
import { Row } from './row';
import { GA } from './ga/ga';
import { Seat } from './seat';
import { Section } from './sections/section';

const mappings = {
  [TYPE.BLOCK]: Block,
  [TYPE.TABLE]: TableHelper,
  [TYPE.SHAPE]: Shape,
  [TYPE.PREDEFINED]: PredefinedShape,
  [TYPE.GA]: GAHelper,
  [TYPE.TEXT]: Text,
  [TYPE.SECTION]: SectionHelper,
} as const;
const mappings2 = {
  [TYPE.BLOCK]: Block,
  [TYPE.TABLE]: Table,
  [TYPE.SHAPE]: Shape,
  [TYPE.PREDEFINED]: PredefinedShape,
  [TYPE.GA]: GA,
  [TYPE.TEXT]: Text,
  [TYPE.SECTION]: Section,
} as const;

export default function fromJSON<T extends { type: keyof typeof mappings }, J extends (typeof mappings2)[T['type']]>(
  params: T
) {
  const { type } = params;
  const Obj = mappings[type];
  return Obj.fromJSON(params) as InstanceType<J>;
}

export type Unit = Shape | Block | Row | Table | TableSeat | PredefinedShape | Text | GA | Seat | Section;
export type Clonable = Exclude<Unit, Block | Row | Table | TableSeat>;
